var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "h3",
    {
      staticClass:
        "font-16 margin-bottom-10 margin-top-15 font-weight color-333",
    },
    [_c("span", { domProps: { innerHTML: _vm._s(_vm.title) } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }